import React, { Component } from 'react';
import './DarkSelect.css';

class DarkSelect extends Component {
  constructor(props) {
    super(props);

    this.reselect = this.reselect.bind(this);
    this.showOptions = this.showOptions.bind(this);
    this.changeSelection = this.changeSelection.bind(this);
    this.deselectOnClick = this.deselectOnClick.bind(this);

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);

    this.options = props.options.map((option) =>
      <li id={option[1]}
        className="dark-select-option"
        onClick={this.reselect}
      >
        {option[0]}
      </li>
    );

    let optionsHeight = this.options.length * this.props.minorHeight;

    this.state = {
      "lock": false,
      "optionsHeight": this.options.length * this.props.minorHeight,
      "slideSpeed": optionsHeight / this.props.slideSpeed,
    };
  }

  componentDidMount() {
    this.state.lock = true;

    this.hide(this.refs.options);
    this.refs.options.style.transition = "max-height " + this.state.slideSpeed + "s ease";

    let firstChild = this.refs.options.children[0].children[0];
    this.state.selectedOption = firstChild;
    this.changeSelection(firstChild);
    this.disable(firstChild);

    document.addEventListener("click", this.deselectOnClick);

    console.log("Mounting");
    console.log(this);
  }

  componentWillUnmount() {
    this.state.lock = true;

    document.removeEventListener("click", this.deselectOnClick);
    console.log("Unmounting");
  }

  disable(component) {
    if (!component.classList.contains("disabled")) {
      component.classList.add("disabled");
    }
  }

  enable(component) {
    if (component.classList.contains("disabled")) {
      component.classList.remove("disabled");
    }
  }

  show(options) {
    options.style.maxHeight = "" + this.state.optionsHeight + "px";
  }

  hide(options) {
    options.style.maxHeight = 0;
  }

  deselectOnClick() {
    if (!this.state.lock) {
      console.log(this);
      this.hide(this.refs.options);
    }
    this.state.lock = false;
  }

  showOptions(e) {
    e.preventDefault();

    let options = this.refs.options;
    this.show(options);
    this.state.lock = true;
  }

  reselect(e) {
    e.preventDefault();

    let clicked = e.target;
    this.changeSelection(clicked);

    this.enable(this.state.selectedOption);
    this.disable(e.target);
    this.state.selectedOption = clicked;
    this.state.lock = true;
  }

  changeSelection(option) {
    let prompt = this.refs.prompt;
    prompt.innerHTML = option.innerHTML;
    this.props.changeSelection(option.id);
  }

  render() {
    return (
      <div className="dark-select">
        <div className="dark-select-prompt"
             onClick={this.showOptions}>
             <p ref="prompt">
             </p>
        </div>
        <div className="dark-select-options-wrapper">
          <div ref="options" className="dark-select-options">
            <ul>
              {this.options}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default DarkSelect;

// Can be:
//    Idle
//    Open
//    Enabled



// WEBPACK FOOTER //
// ./src/DarkSelect.js